import script from "./picture-single-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./picture-single-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./picture-single-setting-ly.vue?vue&type=style&index=0&id=052a0330&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052a0330"]])

export default __exports__